import { render } from "./CheckoutsList.vue?vue&type=template&id=25e42644&scoped=true"
import script from "./CheckoutsList.vue?vue&type=script&lang=js"
export * from "./CheckoutsList.vue?vue&type=script&lang=js"

import "./CheckoutsList.vue?vue&type=style&index=0&id=25e42644&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e42644"]])

export default __exports__